module.exports = __webpack_public_path__ + "static2023-4-17/img/global-red-packet.932be89e.png";